import React from "react";
import { useNavigate } from "react-router-dom";
import { PinIcon, SearchIcon } from "meistericons";
import Logo from "./Logo";
import Button from "./Button";
import { routes } from "../utils/routes";
import { motion } from "framer-motion";

type NavbarProps = {
  search?: boolean;
  searchQuery?: string;
  searchOnChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchSuggestions?: any;
  suggestOnClick?: any;
};

function Navbar({
  searchQuery,
  searchOnChange,
  search,
  searchSuggestions,
  suggestOnClick,
}: NavbarProps) {
  const navigate = useNavigate();

  const searchAnimationInitial = {
    y: search ? 380 : 0,
  };
  const searchAnimate = {
    y: 0,
    transition: {
      duration: 0.2,
    },
  };

  return (
    <motion.div
      initial={search && searchAnimationInitial}
      animate={search && searchAnimate}
      exit={search ? searchAnimationInitial : ""}
      className={`${
        search
          ? "sticky top-0 gap-4 sm:gap-32 md:gap-60 lg:gap-64 xl:gap-[307px] bg-white h-20 z-50"
          : "justify-between"
      } inline-flex items-center w-full mt-10`}
    >
      <Logo />
      <div className="w-full inline-flex items-center">
        {search && (
          <div className="relative inline-flex items-center justify-between w-full">
            <motion.div
              initial={{
                height: 80,
              }}
              animate={{
                height: 50,
                transition: {
                  duration: 0.5,
                },
              }}
              className="w-full h-[50px] py-3 px-5 inline-flex items-center justify-between border-[1px] border-grey-300 rounded-[100px] xl:w-1/2 md:gap-2.5"
            >
              <div className="relative inline-flex gap-2 w-full">
                <PinIcon className="text-grey-500" />
                <input
                  value={searchQuery}
                  onChange={searchOnChange}
                  placeholder="Satungal, Kathmandu"
                  className="border-white w-full h-full text-grey-600
            focus:outline-none"
                />
              </div>
            </motion.div>

            {searchSuggestions.length > 0 && (
              <ul className="absolute top-14 bg-white rounded-md shadow-md py-2 z-10">
                {searchSuggestions.map((suggestion: any) => (
                  <li
                    key={suggestion.id}
                    className="bg-white px-4 rounded-sm whitespace-nowrap
                hover:bg-grey-300 hover:cursor-pointer"
                    onClick={() => suggestOnClick(suggestion)}
                  >
                    <p>{suggestion.place_name}</p>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>

      <Button text="Submit Yours" />
    </motion.div>
  );
}

export default Navbar;
